import { useState } from 'react';
import { v4 } from 'uuid';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useId = /* @__PURE__ */ __name(() => {
  const [uuid] = useState(v4());
  return uuid;
}, "useId");

export { useId };
//# sourceMappingURL=use-id.js.map
